import { WebsiteBlockContactFormDisplayItem, WebsiteBlockContactFormType, WebsiteBlockLoginFormDisplayItem, WebsiteBlockLoginFormType, WebsiteBlockSignupFormType, WebsiteBlockTextAndMediaDisplayItem, WebsiteBlockTextAndMediaType, WebsiteBlockType, WebsiteRenderContextDisplayItem } from '@sb/library/data-models';
import { Field, Scope } from '../base';

export const photoGalleryCarouselMaxItems: number = 15;

export enum LoginFormMode {
    Normal = 'Normal',
    ForgotPassword = 'ForgotPassword',
    AlreadyLoggedIn = 'AlreadyLoggedIn',
    MultipleJWTs = 'MultipleJWTs',
    ResetPasswordThankYou = 'ResetPasswordThankYou',
    ManualRedirect = 'ManualRedirect',
    MfaRequired = 'MfaRequired',
    OtpRequired = 'OtpRequired',
}

export enum WebsiteBlockWidgetType {
    Signup = 'Signup',
    Contact = 'Contact',
    Login = 'Login',
}

export enum WebsiteBlockAction {
    MoveUp = 'MoveUp',
    MoveDown = 'MoveDown',
    Delete = 'Delete',
    Edit = 'Edit',
    MediaGallery = 'MediaGallery',
    Copy = 'Copy',
}

export enum WebsiteBlockImageAction {
    MoveLeft = 'MoveLeft',
    MoveRight = 'MoveRight',
    Delete = 'Delete',
    Add = 'Add',
    MediaGallery = 'MediaGallery',
    Details = 'Details',
}

export enum ExternalWidgetsTab {
    Signup = "Signup",
    BookFromAvailability = "BookFromAvailability",
    BookFromCalendar = "BookFromCalendar",
    Login = "Login",
    Contact = "Contact",
    Reviews = "Reviews"
}

export interface WebsiteBlockTypeData {
    BlockType: WebsiteBlockType;
    BlockSubtype: WebsiteBlockContactFormType | WebsiteBlockLoginFormType | WebsiteBlockTextAndMediaType;
}

export interface WebsiteBlockImageIndexItem {
    ImageIndex: number;
    Block: WebsiteBlockTextAndMediaDisplayItem | WebsiteBlockContactFormDisplayItem | WebsiteBlockLoginFormDisplayItem;
}


export class WebsiteBookingConfigurationDialogData {
    RenderContext!: WebsiteRenderContextDisplayItem;
    HasOpenLessonSlots: boolean = true;
    HasVisibleTeachers: boolean = true;
    HasTeachersWithAvailabilityAndOnlineBooking: boolean = true;
    SignUpFormType!: WebsiteBlockSignupFormType;

    constructor(initializer?: Partial<WebsiteBookingConfigurationDialogData>) {
        if (initializer) {
            Object.assign(this, initializer);
        }
    }
}

export class WebsiteBuilderPreviewScope extends Scope {
    RouteCalendar = Field<() => void>();
    RouteTeachers = Field<() => void>();
    RouteMyProfile = Field<() => void>();
    canRouteToTeachers = Field<boolean>();
}

export const metaPixelScriptRegex = /fbq[\S\s]*https?:\/\/connect\.facebook\.net\/[a-zA-Z_\/.-]*fbevents\.js/;
export const googleAnalyticsScriptRegex = /(googletagmanager\.com\/gtag\/js|google-analytics\.com\/(analytics\.js|ga\.js)|gtag\s*\(|ga\s*\(|__gaTracker)/;
export const scriptTagRegex = /<script[^>]*>/i;
